import type { WidgetRegistryEntry } from "../types";

// Lazy load widget components
import MetricWidget from "./MetricWidget";
import StatWidget from "./StatWidget";
import AdditionalStatWidget from "./AdditionalStatWidget";
import PieChartWidget from "./PieChartWidget";
import AreaChartWidget from "./AreaChartWidget";
import BarChartWidget from "./BarChartWidget";
import TableWidget from "./TableWidget";
import CommissionWidget from "./CommissionWidget";
import CustomChartWidget from "./CustomChartWidget";
import CustomMetricWidget from "./CustomMetricWidget";

export const WIDGET_REGISTRY: Record<string, WidgetRegistryEntry> = {
  metric: {
    type: "metric",
    label: "Metric Card",
    icon: "M",
    category: "metrics",
    component: MetricWidget,
    defaultSize: { w: 4, h: 4 },
    minSize: { w: 3, h: 3 },
    maxSize: { w: 6, h: 6 },
    compatiblePages: "all",
  },
  stat: {
    type: "stat",
    label: "Stat Card",
    icon: "S",
    category: "metrics",
    component: StatWidget,
    defaultSize: { w: 3, h: 2 },
    minSize: { w: 2, h: 2 },
    maxSize: { w: 6, h: 4 },
    compatiblePages: "all",
  },
  additionalStat: {
    type: "additionalStat",
    label: "Additional Stat",
    icon: "A",
    category: "metrics",
    component: AdditionalStatWidget,
    defaultSize: { w: 4, h: 3 },
    minSize: { w: 2, h: 3 },
    maxSize: { w: 6, h: 6 },
    compatiblePages: "all",
  },
  commission: {
    type: "commission",
    label: "Commission Card",
    icon: "%",
    category: "metrics",
    component: CommissionWidget,
    defaultSize: { w: 12, h: 4 },
    minSize: { w: 6, h: 3 },
    maxSize: { w: 12, h: 6 },
    compatiblePages: ["closers", "setters"],
  },
  customMetric: {
    type: "customMetric",
    label: "Custom Scorecard",
    icon: "C",
    category: "metrics",
    component: CustomMetricWidget,
    defaultSize: { w: 4, h: 4 },
    minSize: { w: 3, h: 2 },
    maxSize: { w: 6, h: 6 },
    compatiblePages: "all",
  },
  pieChart: {
    type: "pieChart",
    label: "Pie Chart",
    icon: "P",
    category: "charts",
    component: PieChartWidget,
    defaultSize: { w: 6, h: 8 },
    minSize: { w: 4, h: 6 },
    maxSize: { w: 12, h: 12 },
    compatiblePages: "all",
  },
  areaChart: {
    type: "areaChart",
    label: "Area Chart",
    icon: "L",
    category: "charts",
    component: AreaChartWidget,
    defaultSize: { w: 6, h: 8 },
    minSize: { w: 4, h: 5 },
    maxSize: { w: 12, h: 12 },
    compatiblePages: "all",
  },
  barChart: {
    type: "barChart",
    label: "Bar Chart",
    icon: "B",
    category: "charts",
    component: BarChartWidget,
    defaultSize: { w: 6, h: 8 },
    minSize: { w: 4, h: 5 },
    maxSize: { w: 12, h: 12 },
    compatiblePages: "all",
  },
  table: {
    type: "table",
    label: "Data Table",
    icon: "T",
    category: "tables",
    component: TableWidget,
    defaultSize: { w: 12, h: 8 },
    minSize: { w: 6, h: 5 },
    maxSize: { w: 12, h: 16 },
    compatiblePages: "all",
  },
  customChart: {
    type: "customChart",
    label: "Custom Chart",
    icon: "C",
    category: "custom",
    component: CustomChartWidget,
    defaultSize: { w: 6, h: 8 },
    minSize: { w: 4, h: 5 },
    maxSize: { w: 12, h: 12 },
    compatiblePages: "all",
  },
};

export function getWidgetComponent(type: string): WidgetRegistryEntry | undefined {
  return WIDGET_REGISTRY[type];
}

export function getCompatibleWidgets(page: string): WidgetRegistryEntry[] {
  return Object.values(WIDGET_REGISTRY).filter(
    (w) => w.compatiblePages === "all" || w.compatiblePages.includes(page)
  );
}
